import { render, staticRenderFns } from "./MaterialButton.vue?vue&type=template&id=1ced59f4&scoped=true&"
import script from "./MaterialButton.vue?vue&type=script&lang=js&"
export * from "./MaterialButton.vue?vue&type=script&lang=js&"
import style0 from "./MaterialButton.vue?vue&type=style&index=0&id=1ced59f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ced59f4",
  null
  
)

export default component.exports